import React from 'react';

export default function Notes({ notes, max_print_speed, impact_strength, tensile_strength, hardness, hardness_scale, use_adhesive, additional_properties }) {
  return (
    <div>
      <div className="small">
        <strong>Właściwości:</strong>
        <div>Maksymalna prędkość druku: {max_print_speed ?? 'Brak danych'} mm/s</div>
        <div>Udarność: {impact_strength ?? 'Brak danych'} kJ/m²</div>
        <div>Wytrzymałość na rozciąganie: {tensile_strength ?? 'Brak danych'} MPa</div>
        <div>Twardość: {hardness !== null && hardness !== undefined ? `${hardness} ${hardness_scale || ''}`.trim() : 'Brak danych'}</div>
        <div>Środek adhezyjny: {use_adhesive ? 'Tak' : 'Nie'}</div>
      </div>
          {additional_properties ? (
            typeof additional_properties === 'string' ? (
              (() => {
                const text = additional_properties.trim();
                if (/\r?\n/.test(text)) {
                  const lines = text.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
                  return (
                    <div className="mt-2 small">
                      <strong>Właściwości dodatkowe:</strong>
                      <ul className="mb-0">
                        {lines.map((l, i) => <li key={i}>{l}</li>)}
                      </ul>
                    </div>
                  )
                }
                const re = /-\s*([^\-\n\r]+)/g;
                const items = [];
                let m;
                while ((m = re.exec(text)) !== null) {
                  const v = (m[1] || '').trim();
                  if (v) items.push(v);
                }
                if (items.length > 0) {
                  return (
                    <div className="mt-2 small">
                      <strong>Właściwości dodatkowe:</strong>
                      <ul className="mb-0">
                        {items.map((it, i) => <li key={i}>{it}</li>)}
                      </ul>
                    </div>
                  )
                }
                return (
                  <div className="mt-2 small">
                    <strong>Właściwości dodatkowe:</strong>
                    <div className="mb-0">{text}</div>
                  </div>
                )
              })()
            ) : (
              Object.keys(additional_properties).length > 0 && (
                <div className="mt-2 small">
                  <strong>Właściwości dodatkowe:</strong>
                  <ul className="mb-0">
                    {Object.entries(additional_properties).map(([k, v]) => (
                      <li key={k}><strong>{k}:</strong> {typeof v === 'object' ? JSON.stringify(v) : String(v)}</li>
                    ))}
                  </ul>
                </div>
              )
            )
          ) : (
            <div className="mt-2 small">
              <strong>Właściwości dodatkowe:</strong>
              <p className="small mb-2">-</p>
            </div>
          )}
    </div>
  );
}
